import { render, staticRenderFns } from "./LicenceGenerate.vue?vue&type=template&id=2017d410"
import script from "./LicenceGenerate.vue?vue&type=script&lang=ts"
export * from "./LicenceGenerate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports